import { render, staticRenderFns } from "./PatientCenterInfo.vue?vue&type=template&id=5552f2d9&scoped=true"
import script from "./PatientCenterInfo.vue?vue&type=script&lang=ts"
export * from "./PatientCenterInfo.vue?vue&type=script&lang=ts"
import style0 from "./PatientCenterInfo.vue?vue&type=style&index=0&id=5552f2d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5552f2d9",
  null
  
)

export default component.exports